import { render, staticRenderFns } from "./distributionWlserviceList.vue?vue&type=template&id=0f811635&scoped=true&"
import script from "./distributionWlserviceList.vue?vue&type=script&lang=js&"
export * from "./distributionWlserviceList.vue?vue&type=script&lang=js&"
import style0 from "./distributionWlserviceList.vue?vue&type=style&index=0&id=0f811635&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f811635",
  null
  
)

export default component.exports